import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

export const PAYMENT_METHOD_LABELS = { bank_transfer: '銀行振込', cash: '現金', credit_card: 'クレジットカード' };

export const todayJst = () => new Date(Date.now() + 9 * 3600 * 1000).toISOString().slice(0, 10);

export const jstDate = (iso) => (iso ? new Date(new Date(iso).getTime() + 9 * 3600 * 1000).toISOString().slice(0, 10) : '');

// 入金確認の共通入力項目：入金方法・確認担当者・備考・質問・確認年月日（自動）
export const PaymentConfirmFields = ({ data, setData, confirmedDate, testPrefix = 'payment-confirm' }) => (
  <>
    <div>
      <Label className="text-sm font-medium">入金方法 <span className="text-red-500">*</span></Label>
      <select data-testid={`${testPrefix}-method-select`} value={data.paymentMethod || ''}
        onChange={(e) => setData((d) => ({ ...d, paymentMethod: e.target.value }))}
        className="mt-1 w-full border rounded-md px-3 py-2 text-sm bg-white">
        <option value="">選択してください</option>
        {Object.entries(PAYMENT_METHOD_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
    <div>
      <Label className="text-sm font-medium">確認担当者 <span className="text-red-500">*</span></Label>
      <Input data-testid={`${testPrefix}-confirmed-by`} value={data.confirmedBy || ''} className="mt-1" placeholder="担当者名を入力"
        onChange={(e) => setData((d) => ({ ...d, confirmedBy: e.target.value }))} />
    </div>
    <div>
      <Label className="text-sm font-medium">備考・質問</Label>
      <Textarea data-testid={`${testPrefix}-note`} value={data.paymentNote || ''} className="mt-1" rows={3} placeholder="備考・質問"
        onChange={(e) => setData((d) => ({ ...d, paymentNote: e.target.value }))} />
    </div>
    <div>
      <Label className="text-sm font-medium">確認年月日（自動）</Label>
      <div data-testid={`${testPrefix}-confirmed-date`} className="mt-1 rounded-md border bg-gray-50 px-3 py-2 text-sm text-gray-700">
        {(confirmedDate || todayJst()).replace(/-/g, '/')}
      </div>
    </div>
  </>
);
